<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        d="M293.2 952c-52.6-.2-103.3-22.4-139.1-61-77.2-81.7-77.2-214.6-.1-296.2l3-3.2v-.2l74-82.5c1.7-1.8 7-5.1 14.8-5.1 9.1 0 18.8 4.5 27.8 13.1 20.4 23.3 6.4 38.2 1.9 43.2l-.2.3-74.8 85.8c-50 54.3-50 139.2.1 193.4l.1.1c24.7 26.1 57.5 40.5 92.4 40.5 35.1-.1 68.8-14.8 92.7-40.5l163.8-173.2c48.7-52.7 46.1-144.7-5.6-200.9-10.6-13-7.6-27.6 8.8-43.5 8.1-7.7 18.6-12.4 28-12.4 6.2 0 11.4 2 15.6 6 37.2 39.5 57.7 93.1 57.7 151 0 58-20.6 111.7-57.9 151.2L432.4 891c-35.8 38.7-86.5 60.9-139.2 61zm159-340.9c-11.6 0-21.6-5.6-24.4-8.7-77.2-81.7-77.2-214.6-.1-296.3L591.5 133c35.9-38.7 86.6-60.9 139.3-61 52.5 0 101.9 21.6 139.1 60.9 77.1 81.7 77.1 214.5 0 296.2l-75 79.3c-2.8 3-9.9 8.1-19.1 8.1-8.2 0-16.6-4-24.8-12-14.4-14-15.6-33.5-2.8-47.4l75-79.2c50.1-54.3 50.1-139.3 0-193.6-23.8-25.7-57.5-40.4-92.5-40.5-35 0-67.8 14.3-92.5 40.4l-164 173.3c-48.3 52.3-44.5 145 8.2 202.6 10.4 14.7 8.5 24.3-8.1 42.2-6.2 5.8-13.7 8.8-22.1 8.8z"
        data-follow-fill="currentColor"
        :fill="_fill"
      />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
